if (!customElements.get('cto-product-financing')) {
  customElements.define(
    'cto-product-financing',
    class ProductFinancing extends HTMLElement {
      constructor() {
        super();

        const url = window.location.href;
        this.selectedOption = this.querySelector('.js-cto-selected-option');
        this.inputs = this.querySelectorAll('.js-cto-financing-input');
        this.summarySelectedOption = document.querySelector('.js-cto-summary-financing');
        this.summarySelectedFinancingPrice = document.querySelector('.js-cto-summary-financing-price');

        if (url.includes('products')) {
          const selectDefault = this.querySelector('input#decline-financing');
          const selectDefaultLabel = this.querySelector('label[for="decline-financing"]');
          const selectedDefaultText = this.querySelector('.js-cto-selected-option');
          selectDefault.click();
          selectedDefaultText.innerText = selectDefaultLabel.innerText;
        }


        this.addEvents();
      }

      addEvents() {
        this.inputs.forEach((input) => {
          input.addEventListener('change', () => {
            this.selectedOption.textContent = this.querySelector(`label[for="${input.id}"]`).textContent;

            if (input.value === 'Pay in full') {
              this.summarySelectedOption.classList.remove('hidden');
              this.summarySelectedFinancingPrice.classList.add('hidden');
            } else {
              this.summarySelectedOption.classList.add('hidden');
              this.summarySelectedFinancingPrice.classList.remove('hidden');
            }
          });
        });
      }
    }
  );
}
